import { createCollectionActions } from 'utils/actionsGenerator';

import { types } from './reducer';

export const { post } = createCollectionActions({
    name: 'email-settings',
    types,
    url: '/email-settings',
});

export const put = (data) => ({
    data,
    payload: {
        request: {
            data,
            method: 'put',
            url: `/email-settings/${data.get('id')}`,
        },
    },
    types: ['PUT_EMAIL_SETTINGS', 'PUT_EMAIL_SETTINGS_SUCCESS', 'PUT_EMAIL_SETTINGS_FAIL'],
});

export const saveEmailSettings = (data) => (dispatch) => {
    return data.get('id')
        ? dispatch(put(data))
        : dispatch(post(data));
};



// WEBPACK FOOTER //
// ./src/redux/emailSettings/actions.js